<div class="rs-header">
  <div class="rs-header_logo">
    <img src="assets/images/rockpoon-logo.png" />
  </div>
</div>
